<discover-tiles
  #discoverTiles
  [tiles]="tiles"
  [options]="discoverTilesOptions"
  [businessVertical]="'groceries'"
  (tileToggle)="onTileToggle($event)"
></discover-tiles>
